import { LayoutRoute } from "../../../types";
import { SELECT_TAB, SelectTabAction } from "./actionTypes";

export const selectTab = (tab: LayoutRoute): SelectTabAction => ({
  type: SELECT_TAB,
  payload: tab,
  tabId: tab.tabId
});
